import { useModals } from 'almanac-ui/Modal'
import { Search } from 'blaze-ui/icons'
import { SearchModal } from 'screens/blaze/Search/SearchModal/SearchModal'
import { Button } from './Button'

export const SearchIconButton = () => {
  const { openModal } = useModals()

  return <Button icon={Search} aria-label="Search" onPress={() => openModal(SearchModal, {})} />
}
